import {useState} from "react";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const steps = [
  {
    label: 'REGISTER',
    description: 
    `Please confirm link sent to your email address. After successful email confirmation please sign in with your credentials to continue with onboarding.`,
  },
  {
    label: 'COMPLETE DATA',
    description:
      `Please complete required personal data.`,
  },
  {
    label: 'ORDER GENOME & MICROBIOME TEST',
    description:
      `Please order required genome and microbiome tests and make payment.`,
  },
  {
    label: 'BLOOD & STOOL SAMPLES COLLECTION',
    description: `Please confirm sample IDs (press button) and then return samples according to instructions `,
  },
  {
    label: 'ORDER SUBSCRIPTION PLAN',
    description: ` `,
  },
   {
      label: 'COUNSELING SESSION ONLINE',
      description: ``,
    },
    {
      label: 'ENJOY PREVENTIVE HEALTH INTELLIGENCE',
      description: ``,
      },
];



export default function OnboardingStep4() {
  
  const [activeStep, setActiveStep] = useState(3);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  
  
  return (

    <Box sx={{ maxWidth: 700, }}>
    
    <Stepper activeStep={activeStep} orientation="vertical">
    
      {steps.map((step, index) => (
    
        <Step key={step.label} sx={{
           "& .MuiStepIcon-root": {color: 'grey.C900'},
          "& .MuiStepLabel-root .Mui-active": { color: "traffic.red", },
          "& .MuiStepLabel-root .Mui-completed": { color: "traffic.green" }, }}
        >
    
    
          <StepLabel
            optional={
              index === steps.length - 1 ? (
                <Typography variant="subtitle2" sx={{color: 'common.black'}}>Congratulation ! </Typography>
              ) : null
            }
          >
           <Typography variant="subtitle2" sx={{color: 'common.black'}}>{step.label}</Typography>
          </StepLabel>

          <StepContent>
          <Typography variant="subtitle2" sx={{ color: 'common.black'}}>{step.description}</Typography>
          </StepContent>
        </Step>
      ))}
    </Stepper>
    {activeStep === steps.length && (
      <Paper square elevation={0} sx={{ p: 3 }}>
        <Typography>All steps completed - you are finished</Typography>
        <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
          Reset
        </Button>
      </Paper>
    )}
  </Box>
);
}